import { DB } from '@/extensions/db'

let instance = null

export class Metadata {
  constructor () {
    instance = instance || this

    this._table = DB.metadata

    return instance
  }

  async get (id) {
    return this._table.get(id)
  }

  async all () {
    return this._table.toArray()
  }

  async update (id, data) {
    return this._table.update(id, data)
  }

  async updatePoint (id, index, data) {
    let tmp = await this.get(id)

    tmp.points[index] = Object.assign(tmp.points[index], data)

    this.update(id, tmp)
  }
}



// WEBPACK FOOTER //
// ./src/models/metadata.js